module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("57HV1"))).then(() => parcelRequire('hEqeo'));